import React, { Component } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import { styled } from '@mui/system';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio, { RadioProps } from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';



const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


export default class Adminoption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logredirect: false, pagename: '',ao_id:0,type:'',ao_description: '',adminarray:[],label: 'Select Name',desc: '',
      redirect: false,aoid:'',ids:'',textcountmin:0,errormessage:'',namearray:[],BusiCustomerData:[],
textcountmax:200, successMessage: '',submitbtn:'save',
      showSuccessMessage: false,
    };
  }

componentWillMount() {
	
	document.title = "Document preferences ";
	
	 if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{
 
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			
			
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		 this.props.parentdasCallback(
            "Document preferences  ~"
        );

	    this.apicall(); 

} 

PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=21')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
	
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
  apicall ()  {
	  let strsettings=[];
	  let strname=[];
    axios.get(localStorage.getItem("ISIurl")+'ajaxadminoption.php?action=list&ao_type=4'+'&ao_cmp_id='+localStorage.getItem("ISIcmpid"))
      .then((response) => {
		
		 var strararay=response.data;
		  const items=[];
		 strararay.map((row, i) => { 
		let strval="1";
			 if(i===0)
			 {
		   strval="0";
			 }
			 let strvalue="1";
			 if(i===3)
			 {
		   strvalue="0";
			 }
		
		  const items = {ao_id:row.ao_id,ao_name:row.ao_name,ao_description:row.ao_description,isdisplay:strval,display:strvalue}
        strsettings.push(items)
      })
	
	  
	  console.log(strsettings)
      this.setState({ adminarray:strsettings }); 

	  })
	 this.GetCustomerSetting(); 
  };
  
   
   
   GetCustomerSetting() {
  let strset = [];
  axios
    .get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=3'+'&bs_cmp_id='+localStorage.getItem("ISIcmpid"))
    .then(resp => {
      if (resp.data.length > 0) {
        resp.data.map((row, i) => {
          const items = {
            bs_id: row.bs_id,
            bs_title: row.bs_title,
            bs_value:row.bs_value, 
            bs_page: row.bs_page,
		 };

          strset.push(items);
        });

     
        this.setState({
          BusiCustomerData: strset,
        },()=>{

          console.log(this.state.strset)


        });
      } else {
        this.setState({BusiCustomerData: []});
      }

    });
}
   
 onclickCancel = (e) => {
	this.setState({redirect:true,pagename:'/settings'});
 }


  HandleSetting = (bs_id, index) => {
    return (event) => {
		const value = event.target.value; 
      const updatedData = [...this.state.BusiCustomerData];
      updatedData[index].bs_value = event.target.value;
      this.setState({ BusiCustomerData: updatedData });
    };
  }




  myChangeHandler = (firstrow) => event  => { 
  let nam = event.target.name;
  let val = event.target.value;
    const updatearray = [...this.state.adminarray]
	
	
	if(nam==="ao_description")
	{
		    if (val.length <= this.state.textcountmax) {
            this.setState({
                [nam]: val,           
                textcountmin: val.length 
            });
        }
		updatearray[firstrow].ao_description = val
	
	}
	
	
      this.setState({ adminarray:updatearray }); 
	  
	  
 }
	

	
	
	
	
	
	
handleSelectChange = (index) => {
   const updatearray = [...this.state.adminarray]
 


 
 updatearray.map((rowssub,j) => {
                      rowssub.isdisplay = "1" ;
                                 });
                                                             
              
  if(updatearray[index].isdisplay === "0") {
    
	updatearray[index].isdisplay = "1" 

  } 

              

  else {
   
    updatearray[index].isdisplay = "0"  
  }
  
   this.setState({adminarray:updatearray}); 
}

  myChangeHandlerPV = (index, bs_id) => {
    return (event) => {
      const updatedData = [...this.state.BusiCustomerData];
      updatedData[index].bs_value = event.target.checked ? '1' : '0';
      this.setState({ BusiCustomerData: updatedData });
    };
  }



handleSelectChangenotes = (index) => {
   const updatearray = [...this.state.adminarray]
 
 

 
 updatearray.map((rowssub,j) => {
                      rowssub.display = "1" ;
                                 });
                                                              
              
  if(updatearray[index].display === "0") {
    
	updatearray[index].display = "1" 

  } 

  else {
   
    updatearray[index].display = "0" 
  }
  
   this.setState({adminarray:updatearray}); 
}






	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

  

    handleSubmit = (event) => {
    event.preventDefault();
      let optionsVals=this.state.BusiCustomerData;
    let sep1 = '';
    let optionValues = '';

let optioncustValues="";
    let sep2="";
	 
	  optionsVals.forEach(eachvals => {
     
		 optioncustValues=optioncustValues+sep2+eachvals.bs_id+"~"+eachvals.bs_value;
		 sep2="`"
		
		   
	   });
 
    const formData = new FormData();
	
	
	formData.append('action','update')
	 formData.append('business',optioncustValues)
	 formData.append('bs_page',3)
	 
	 
     formData.append('bs_cmp_id',localStorage.getItem("ISIcmpid"))
     formData.append('userid',localStorage.getItem("ISIuserid"))
	 
	 axios.post(localStorage.getItem("ISIurl")+"ajaxbusinesssetting.php", formData, {
        }).then(res => {
			
			this.setState({btndisabled:false,submitbtn:"Save"})
this.GetCustomerSetting();
			
		
   }); 
	
	
	
	
    formData.append('action', 'BulkUpdate');
    
    let optionsVal = this.state.adminarray;
    optionsVal.forEach(eachval => {
      if(eachval.ao_id !== ""){  
        optionValues += sep1 + eachval.ao_id + "~" + eachval.ao_description; 
        sep1 = '`'
      }
    });

    formData.append('ao_description', optionValues);

    axios.post(localStorage.getItem("ISIurl")+'ajaxadminoption.php', formData)
      .then((res) => {
      this.setState({
            btndisabled: false,
            submitbtn: "Save",
         
            errormessage: "Updated Successfully", 
            erropen: true,
            successMessage: 'Admin Option updated successfully!',
            showSuccessMessage: true,
          });
      })
   
   this.GetCustomerSetting();
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
	<React.Fragment> 
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
      <div className="page-container">
  
  
  
  
    <div className="termsandcondition">
  <h3>DOCUMENT HEADING</h3>
  <p>Depending on the Template and logos selected, these headings can be shown at the top of each document.</p>
</div>

<div className="doc-preinputs">
    <ul> {this.state.BusiCustomerData
.map((item, index) => (
    <React.Fragment >
       {item.bs_id >= "28" && item.bs_id <= "36" &&(
     
          <li className="textlist" key={index}>
            <h6>{item.bs_title}*</h6>
            <TextField
              fullWidth
              name="bs_value"
           onChange={this.HandleSetting(item.bs_id, index)} 
              value={item.bs_value}
              className="txtbox"
			   inputProps={{tabIndex: "1",maxLength:150}}
            />
          </li>
      
	   )}
    </React.Fragment>
  ))}  </ul>
</div>
<div className="clear"></div>
 
   
   
   
   
     <div className="termsandcondition">
  <h3>PREFIXES & NUMBERING</h3>
  <p>A Standard prefix and unique number for each document you create.</p>
</div>


<div className="doc-preinputs">
 <ul>
           <li>
<h5>Prefixes</h5>
  {this.state.BusiCustomerData.map((item, index) => (
    <React.Fragment key={index}>
        {item.bs_id >= "37" && item.bs_id <= "39" &&(
       
            <p>{item.bs_title}*<br/>
            <TextField
              fullWidth
              name="bs_value"
           onChange={this.HandleSetting(item.bs_id,index)} 
              value={item.bs_value}
              className="txtbox"
			   inputProps={{tabIndex: "6",maxLength:4}}
            /></p>
         
		)}
    </React.Fragment>
  ))}

 </li>
       

 <li>
<h5>Numbering</h5> 
  {this.state.BusiCustomerData.map((item, index) => (
    <React.Fragment key={index}>
        {item.bs_id >= "40" && item.bs_id <= "42" &&(
       
        
            <p>{item.bs_title}*<br/>
            <TextField
              fullWidth
              name="bs_value"
          onChange={this.HandleSetting(item.bs_id,index)} 
              value={item.bs_value}
              className="txtbox"
			     inputProps={{tabIndex: "9",maxLength:15}}
            /></p>
          
       
		)}
    </React.Fragment>
  ))} </li>
  </ul>
</div>
<div className="clear"></div>

  
   
   
   
   
       <div className="termsandcondition">
  <h3>CONTACT DETAILS & ADDRESS </h3>
  <p>Selected details appear at the top of all types of document. Complete any missing contact details in Edit Business Address.</p>
</div>

 <div className="doc-contact">
  


  <ul>
  <li>  <h6>Contact Details</h6>
  {this.state.BusiCustomerData.map((rows, i) => {
	   return (
    <React.Fragment >
	  {rows.bs_id >= "48" && rows.bs_id <= "52" &&(
   
         <p> <Checkbox
            name="bs_value"
            value={rows.bs_value}
            sx={{
              '&.Mui-checked svg': {
                fill: 'black',
              },
              marginRight: '8px',
            }}
           onChange={this.myChangeHandlerPV(i, rows.bs_id)}
            checked={rows.bs_value === "1"}
          /> 
          {rows.bs_title}</p>
    
	  )}
    </React.Fragment>
  )
   })}
</li>

   <li>
    {this.state.BusiCustomerData.map((item, index) => {
                  return (    
					
					<React.Fragment > {item.bs_id === "53"&&(
				
				<React.Fragment >
			 <h6>{item.bs_title}*</h6>
				  <FormControl className="preference">
                    <RadioGroup
                      value={item.bs_value}
                      onChange={this.HandleSetting(item.bs_id, index)}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                          color: "green",
                        },
                      }}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Same as Invoice Address"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio />}
                        label="Delivery Address"
                      />
                      <FormControlLabel
                        value="3"
                        control={<Radio />}
                        label="No Address"
                      />
                    </RadioGroup>
                  </FormControl>
				 
				  </React.Fragment >
                  
               
				 )}
			    </React.Fragment >
            )
   })}
     
</li>



<li>
            <h6>Customer Information</h6>
            {this.state.BusiCustomerData.map((rows, i) => (
			   <React.Fragment key={rows}>
				 {rows.bs_id >= "54" && rows.bs_id <= "55" &&(
            <p>
                  <Checkbox
                    name="bs_value"
                    value={rows.bs_value}
                    sx={{
                      '&.Mui-checked svg': {
                        fill: 'black',
                      },
                      marginRight: '8px',
                    }}
                    onChange={this.myChangeHandlerPV(i, rows.bs_id)}
                    checked={rows.bs_value === "1"}
                  />
                 {rows.bs_title}
                </p>
				 )}
				 </React.Fragment>
              ))}
          </li>
         </ul>
        </div>
        <div className="clear"></div>
      
     
   
   
   
   
   
   
       <div className="termsandcondition">
  <h3>TAX DISPLAY BREAKDOWN </h3>
</div>

<div className="doc-preinputs">
  
               
   
       {this.state.BusiCustomerData.map((item, index) => (
          <React.Fragment key={index}>
        {item.bs_id === "47" && (
    <p>  <Select
				 native
				 variant="outlined" className="txtbox"
				  margin="normal"
				  onChange={this.HandleSetting(item.bs_id, index)}
				  id="bs_value"
				 value={item.bs_value}
				 name="bs_value"
					inputProps={{tabIndex: "4"}}
					style={{width:'40%'}}
				>
				 <option value={0}>One-line Summary</option>
				<option value={1}>Combined Tax Rates</option>
				<option value={2}>Individual Tax Rates</option>	
				
				</Select></p>
     )}
	  </React.Fragment> 
  ))}
   
   </div>
   <div className="clear"></div>
   
   
   
   
     <div className="termsandcondition">
  <h3>LINE ITEMS</h3>
  <p>Depending on the Template and logos selected, these headings can be shown at the top of each document.</p>
</div>

<div className="doc-preinputs">
 <ul>

  {this.state.BusiCustomerData.map((item, index) => (
    <React.Fragment key={index}>
        {item.bs_id >= "43" && item.bs_id <= "46" &&(
       
          <li>
            <p>{item.bs_title}*<br/>
            <TextField
              fullWidth
              name="bs_value"
          onChange={this.HandleSetting(item.bs_id, index)} 
              value={item.bs_value}
              className="txtbox"
			     inputProps={{tabIndex: "10",maxLength:150}}
            /></p>
         </li>
		)}
    </React.Fragment>
  ))}
</ul>
</div>
 
   
   <div className="clear"></div>
   
    

  
   
   

	   <div className="termsandcondition">
	<h3>TERMS & CONDITIONS</h3>
	<p>Standard information you'd like to print on each document, such as bank details for payment. You can edit 
	these further when you create each document.</p>
	</div>
	
	
	
 
           
	
	
	
     <div className="doc-preinputs">
	
  <ul className="invoiceform">
    {this.state.adminarray.map((item, index) => {
      return (
        <React.Fragment>
		  {item.ao_id >= "16" && item.ao_id <= "18" &&(
		  
		  <li key={index} 
            onClick={() => {
              this.handleSelectChange(index);
            }} > 
      
            {item.ao_name}
          </li>
		  )} 
         </React.Fragment>
      );
    })}
	</ul>

	
	   
	   <ul className="settingstab">
	 {this.state.adminarray.map((item, index) => {
      return (
          <React.Fragment>
		  {item.ao_id >= "16" && item.ao_id <= "18" && item.isdisplay === "0" &&(
         
            <li>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                multiline
                rows={6}
                name="ao_description"
                onChange={this.myChangeHandler(index)}
                value={item.ao_description}
                autoComplete="ao_description"
                
              />
           
		   <p>You have used {this.state.textcountmin} of {this.state.textcountmax} characters</p>
		   </li> 
          
		  )}
		     </React.Fragment>
			
      );
	  
	  	
 
    })}
		</ul>
	
	  
 </div>

	 
  <div className="clear"></div>
 
	

   <div className="termsandcondition">
	<h3>NOTES</h3>
	<p>Standard information you'd like to print on each document, such as bank details for payment. You can edit 
	these further when you create each document.</p>
	</div>
	
	
	  <div className="doc-preinputs">
	
  <ul className="invoiceform">
    {this.state.adminarray.map((item, index) => {
      return (
	    <React.Fragment>

		  {item.ao_id >= "19" && item.ao_id <= "21" &&(
                 <li key={index}  className="listform"
            onClick={() => {
              this.handleSelectChangenotes(index);
            }}> 
            {item.ao_name}
         
		  </li> )}
          
        </React.Fragment>);
    })}
	</ul>

		    <ul className="settingstab">
		 {this.state.adminarray.map((item, index) => {
      return (
     <React.Fragment>
		  {item.ao_id >= "19" && item.ao_id <= "21" && item.display === "0" &&(
           <li key={index}> 
           
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                multiline
                rows={6}
                name="ao_description"
                onChange={this.myChangeHandler(index)}
                value={item.ao_description}
                autoComplete="ao_description"
                
              />
           
		   <p>You have used {this.state.textcountmin} of {this.state.textcountmax} characters</p>
           </li>
		  )}
		     </React.Fragment>
			  
      );
	  
	  	
 
    })}
	</ul>
	
	
	
	
	
	
	
	
	
	
	
	
	
	</div>
    
  <div className="clear"></div>
       
  


 </div>
 
 
    
		 <div className="salesactions">	
		 <p>
        <Button
          type="submit"
          halfWidth
          variant="contained"
          color="primary"
          id="submit"
          className="frmSecondarybtn"
          onClick={this.handleSubmit}
          key="submitButton"
		  disabled={this.state.btndisabled}
        >
		{this.state.submitbtn}
        </Button>
		&nbsp;
		<Button variant="contained"  color="primary" className="frmSecondarybtn" onClick={this.onclickCancel}>
Cancel
</Button> </p>
</div>

	  </React.Fragment>
    );
  }
}